{
  "title": "Finance Dashboard",
  "revenue_today": "Today's Revenue",
  "revenue_mtd": "Month-to-Date Revenue",
  "orders_today": "Today's Orders",
  "avg_order_value": "Average Order Value",
  "vs_previous": "vs previous period",
  "revenue_chart": "Revenue Trend",
  "last_7_days": "Last 7 days",
  "last_30_days": "Last 30 days",
  "payment_breakdown": "Payment Method Breakdown",
  "wave": "Wave",
  "orange_money": "Orange Money",
  "cod": "Cash on Delivery",
  "brand_revenue": "Revenue by Brand",
  "brand": "Brand",
  "revenue": "Revenue",
  "orders": "Orders",
  "avg_value": "Avg. Value",
  "top_product": "Top Product",
  "tva_panel": "VAT Summary",
  "gross_revenue": "Gross Revenue",
  "tva_rate": "VAT Rate",
  "tva_collected": "VAT Collected",
  "net_revenue": "Net Revenue (excl. VAT)",
  "period": "Period",
  "sage_export": "Sage Export",
  "sage_export_desc": "Generate a Sage-compatible file",
  "download_csv": "Download CSV",
  "period_daily": "Daily",
  "period_weekly": "Weekly",
  "period_monthly": "Monthly",
  "period_quarterly": "Quarterly",
  "countre_dairy": "Countre Dairy",
  "yousra": "Yousra",
  "florida": "Florida",
  "kamax": "KamaX",
  "zone": "Zone",
  "no_data": "No data available",
  "loading": "Loading...",
  "export_generated": "Export generated successfully",
  "fcfa": "FCFA"
}
